<template>
  <FormGroup
    type="ajax-select"
    label-method="name"
    :id-only="true"
    :fetch-models="fetchModels"
    :fetch-options="fetchOptions"
  >
    <template #label="{ selected }">
      <a v-if="selected" class="link" @click.stop="openModal(selected.id)"> Finance company </a>
      <template v-else> Finance company </template>
      <FinanceCompanyShowModal ref="ModalRef" />
    </template>
    <template #controls="{ selected }">
      <a v-if="selected?.url" class="link" :href="selected.url" target="_blank">Website</a>
    </template>
  </FormGroup>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import FinanceCompanyApi from '@/js/Api/FinanceCompany';
import FormGroup from '@/js/Components/Form/FormGroup.vue';
import FinanceCompanyShowModal from './ShowModal.vue';

const fetchModels = (id: number[]) => {
  return FinanceCompanyApi.all({
    queryBuilder: {
      filters: {
        id,
      },
    },
  });
};

const fetchOptions = (query: string | undefined, page: number) => {
  return FinanceCompanyApi.index({
    queryBuilder: {
      page,
      filters: {
        name: query,
      },
    },
  });
};

const ModalRef = ref<InstanceType<typeof FinanceCompanyShowModal> | null>(null);
const openModal = (id: number) => {
  if (!ModalRef.value) return;
  ModalRef.value.open(id);
};
</script>
